import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Services/TradeFinance/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <img
        className={cn('header__background-cloud')}
        src='/images/pages/Services/TradeFinance/background-cloud.svg'
        alt='Background Cloud Image'
      />
      <div className={cn('container')}>

        <Breadcrumbs
          mode="light"
          mTop={64}
          links={[
            { title: 'Services', href: '/services' as Route },
            { title: 'Trade Finance', href: '' as Route },
          ]}
        />

        <div className={cn('header__content')}>

          {/* INFO BLOCK */}
          <div className={cn('header__info-container')}>
            <h1 className={cn('header__heading')}>
              DP World Trade Finance
            </h1>
            <p className={cn('header__description')}>
              Creating access to affordable finance for businesses of all sizes.
            </p>
            {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <div className={cn('header__buttons')}>
              <Link
                className={cn('header__button-sign-up')}
                href='/membership'
              >
                Sign Up Now
              </Link>
            </div> */}
          </div>

          {/* IMAGE BLOCK */}
          <div className={cn('header__image-container')}>
            <picture>
              <source
                srcSet="/images/pages/Services/TradeFinance/header-image@2x.webp 2x, 
                      /images/pages/Services/TradeFinance/header-image.webp 1x"
                sizes="100vw"
              />
              <img
                className={cn('header__image')}
                src="/images/pages/Services/TradeFinance/header-image.webp"
                alt="Trade Finance Image"
              />
            </picture>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;